import React from "react";
import breadcrum from "../css/breadcrum.css";
import arrow_icon from "./Assets/breadcrum_arrow.png";

const BreadCrum = (props) => {
  const {product} = props;
  return (
    <div style={breadcrum} className="breadcrum">
      HOME <img src={arrow_icon} alt="" /> SHOP <img src={arrow_icon} alt="" />{" "}
      {product.category} <img src={arrow_icon} alt="" /> {product.name}
    </div>
  );
};

export default BreadCrum;
